<template>
  <div class="tw-flex tw-items-center tw-justify-between item tw-w-full">
    <div class="tw-flex tw-w-4/12 md:tw-w-3/12 tw-pr-2">
      <v-select 
        :items="identificationType" 
        class="tw-cursor-pointer" 
        label="Documento" 
        filled
        v-model="identification.type" 
        dense 
        light 
        color="#4f1087"
        @input="updateIdentification"
      ></v-select>
    </div>
    <div class="tw-flex tw-w-8/12 md:tw-w-9/12 tw-pl-2">
      <v-text-field 
        label="N° de Identificação" 
        data-checkout="docNumber" 
        :rules="isVisible ? [validateDoc] : []"
        validate-on-blur 
        v-mask="identificationMask" 
        id="docNumber" 
        name="docNumber" 
        type="text"
        v-model="identification.number" 
        dense 
        light 
        color="#4f1087" 
        filled
        @input="updateIdentification"
      ></v-text-field>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentFields',
  props: {
    value: {
      type: Object,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      identification: {
        type: this.value.type || 'CPF',
        number: this.value.number || ''
      },
      identificationType: ['CPF', 'CNPJ']
    }
  },
  computed: {
    identificationMask() {
      return this.identification.type === 'CPF' 
        ? '###.###.###-##' 
        : '##.###.###/####-##'
    }
  },
  methods: {
    updateIdentification() {
      this.$emit('input', this.identification)
    },
    validateDoc() {
      if (!this.isVisible) {
        return true;
      }
      const cleanNumber = this.identification.number.replace(/[^\d]/g, '')

      if (this.identification.type === 'CPF') {
        if (cleanNumber.length !== 11) {
          return 'O CPF precisa ter 11 dígitos'
        }
        if (!this.isValidCPF(cleanNumber)) {
          return 'CPF inválido'
        }
      } else if (this.identification.type === 'CNPJ') {
        if (cleanNumber.length !== 14) {
          return 'O CNPJ precisa ter 14 dígitos'
        }
        if (!this.isValidCNPJ(cleanNumber)) {
          return 'CNPJ inválido'
        }
      }
      return true
    },
    isValidCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, "");

      if (
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
      ) {
        return false;
      }

      let sum = 0;
      let remainder;

      for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      }

      remainder = (sum * 10) % 11;

      if (remainder === 10 || remainder === 11) {
        remainder = 0;
      }

      if (remainder !== parseInt(cpf.substring(9, 10))) {
        return false;
      }

      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      }

      remainder = (sum * 10) % 11;

      if (remainder === 10 || remainder === 11) {
        remainder = 0;
      }

      if (remainder !== parseInt(cpf.substring(10, 11))) {
        return false;
      }

      return true;
    },
    isValidCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, "");

      if (
        cnpj.length !== 14 ||
        cnpj === "00000000000000" ||
        cnpj === "11111111111111" ||
        cnpj === "22222222222222" ||
        cnpj === "33333333333333" ||
        cnpj === "44444444444444" ||
        cnpj === "55555555555555" ||
        cnpj === "66666666666666" ||
        cnpj === "77777777777777" ||
        cnpj === "88888888888888" ||
        cnpj === "99999999999999"
      ) {
        return false;
      }

      let sum = 0;
      let length = cnpj.length - 2;
      let numbers = cnpj.substring(0, length);
      let digits = cnpj.substring(length);
      let position = length - 7;

      for (let i = length; i >= 1; i--) {
        sum += parseInt(numbers.charAt(length - i)) * position--;
        if (position < 2) {
          position = 9;
        }
      }

      let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

      if (result !== parseInt(digits.charAt(0))) {
        return false;
      }

      length += 1;
      numbers = cnpj.substring(0, length);
      sum = 0;
      position = length - 7;

      for (let i = length; i >= 1; i--) {
        sum += parseInt(numbers.charAt(length - i)) * position--;
        if (position < 2) {
          position = 9;
        }
      }

      result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

      if (result !== parseInt(digits.charAt(1))) {
        return false;
      }

      return true;
    },
  }
}
</script>